<template>
  <div class="heji-page">
    <!-- 顶部区：标题与筛选 -->
    <section class="hero">
      <div class="container">
        <h1 class="title">精选合集</h1>
        <p class="subtitle">音乐与动漫的灵感拼图 · 每期严选高质量主题合集</p>

        <div class="filters">
          <div class="pill-group">
            <button
              v-for="(tab) in tabs"
              :key="tab.key"
              :class="['pill', { active: currentTab === tab.key }]"
              @click="currentTab = tab.key"
            >
              {{ tab.label }}
            </button>
          </div>
          <div class="toolbar">
            <div class="search">
              <input v-model="keyword" type="text" placeholder="搜索合集、曲风、题材…" />
            </div>
            <div class="sort">
              <select v-model="sortKey">
                <option value="trending">按热度</option>
                <option value="recent">按更新时间</option>
                <option value="count">按内容数</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 合集卡片区 -->
    <section class="collections">
      <div class="container grid">
        <div
          v-for="item in visibleCollections"
          :key="item.id"
          class="collection-card"
        >
          <div class="cover" :style="bg(item.cover)">
            <div class="tag" :class="item.type === 'music' ? 'tag-music' : 'tag-comic'">
              {{ item.type === 'music' ? '音乐合集' : '漫画合集' }}
            </div>
            <div class="overlay"></div>
          </div>
          <div class="info">
            <h3 class="name">{{ item.name }}</h3>
            <p class="desc">{{ item.desc }}</p>
            <div class="meta-row">
              <div class="meta-left">
                <span class="chip">{{ item.count }} 条内容</span>
                <span class="dot">•</span>
                <span class="meta-item">{{ item.updatedAt }}</span>
              </div>
              <div class="stats">
                <span class="stat"><i>▶</i>{{ formatNumber(item.play) }}</span>
                <span class="stat"><i>❤</i>{{ formatNumber(item.like) }}</span>
              </div>
            </div>
            <div class="actions">
              <router-link v-if="item.type==='music'" class="btn primary" to="/sucai">立即收听</router-link>
              <router-link v-else class="btn outline" to="/manhua">开始阅读</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="container loadmore" v-if="visibleCount < sortedCollections.length">
        <button class="btn more" @click="loadMore">加载更多</button>
      </div>
    </section>

    <!-- 合作主题和说明 -->
    <section class="about">
      <div class="container about-grid">
        <div class="about-text">
          <h2>音乐 × 动漫 合作主题</h2>
          <p class="desc">我们围绕「经典主题曲」「热血战歌」「治愈旋律」到「赛博科幻」「校园日常」「冒险奇幻」等方向，持续发布跨界精选合集，为创作者提供灵感速配方案。</p>
          <ul class="bullets">
            <li>合集每周更新，覆盖不同题材与氛围</li>
            <li>同主题双合集：音乐搭配漫画，沉浸体验</li>
            <li>所有内容均为高质量甄选，便于二创与学习</li>
          </ul>
        </div>
        <div class="about-cards">
          <div class="mini-card music">
            <div class="mini-icon">🎵</div>
            <div class="mini-content">
              <h4>主题曲库</h4>
              <p>流行 / 摇滚 / 电子 / 管弦</p>
            </div>
          </div>
          <div class="mini-card comic">
            <div class="mini-icon">📚</div>
            <div class="mini-content">
              <h4>题材合集</h4>
              <p>热血 / 恋爱 / 科幻 / 奇幻</p>
            </div>
          </div>
          <div class="mini-card mix">
            <div class="mini-icon">✨</div>
            <div class="mini-content">
              <h4>跨界灵感</h4>
              <p>同题联动 · 配乐即视感</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Heji',
  data() {
    return {
      currentTab: 'all',
      keyword: '',
      sortKey: 'trending',
      visibleCount: 6,
      loadStep: 6,
      tabs: [
        { key: 'all', label: '全部' },
        { key: 'music', label: '音乐' },
        { key: 'comic', label: '漫画' }
      ],
      collections: [
        { id: 1, type: 'music', name: '热门动漫主题曲 · Vol.1', desc: '20 首高人气番剧主题曲与 BGM，热血与感动同在', count: 20, updatedAt: '今日更新', play: 1234200, like: 32400,
          cover: "linear-gradient(rgba(0,0,0,.25),rgba(0,0,0,.25)), url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1200 400\"><defs><linearGradient id=\"g\" x1=\"0\" y1=\"0\" x2=\"1\" y2=\"1\"><stop stop-color=\"%238b5cf6\"/><stop offset=\"1\" stop-color=\"%23a855f7\"/></linearGradient></defs><rect width=\"1200\" height=\"400\" fill=\"url(%23g)\"/><circle cx=\"240\" cy=\"160\" r=\"90\" fill=\"%23ffffff33\"/><rect x=\"640\" y=\"120\" width=\"380\" height=\"160\" rx=\"18\" fill=\"%23ffffff22\"/></svg>')" },
        { id: 2, type: 'comic', name: '未来世界 · 科幻精选', desc: '5 部探索未来科技与社会的高分漫画，脑洞大开', count: 5, updatedAt: '本周更新', play: 462000, like: 18200,
          cover: "linear-gradient(rgba(0,0,0,.25),rgba(0,0,0,.25)), url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1200 400\"><rect width=\"1200\" height=\"400\" fill=\"%2306b6d4\"/><rect x=\"80\" y=\"80\" width=\"320\" height=\"200\" rx=\"18\" fill=\"%23ffffff22\"/><circle cx=\"960\" cy=\"180\" r=\"90\" fill=\"%23ffffff33\"/></svg>')" },
        { id: 3, type: 'music', name: '治愈旋律 · 学习与阅读', desc: '精选钢琴与轻电子，适合长时间专注与放松', count: 15, updatedAt: '3 天前', play: 285300, like: 12100,
          cover: "linear-gradient(rgba(0,0,0,.25),rgba(0,0,0,.25)), url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1200 400\"><defs><linearGradient id=\"b\" x1=\"0\" y1=\"0\" x2=\"1\" y2=\"1\"><stop stop-color=\"%2306b6d4\"/><stop offset=\"1\" stop-color=\"%23089db2\"/></linearGradient></defs><rect width=\"1200\" height=\"400\" fill=\"url(%23b)\"/><rect x=\"800\" y=\"80\" width=\"260\" height=\"220\" rx=\"18\" fill=\"%23ffffff22\"/></svg>')" },
        { id: 4, type: 'comic', name: '热血冒险 · 少年精选', desc: '高燃动作场面与伙伴羁绊，畅快阅读体验', count: 8, updatedAt: '本月更新', play: 833000, like: 24100,
          cover: "linear-gradient(rgba(0,0,0,.25),rgba(0,0,0,.25)), url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1200 400\"><rect width=\"1200\" height=\"400\" fill=\"%23f59e0b\"/><circle cx=\"300\" cy=\"180\" r=\"100\" fill=\"%23ffffff33\"/><rect x=\"720\" y=\"120\" width=\"360\" height=\"180\" rx=\"18\" fill=\"%23ffffff22\"/></svg>')" },
        { id: 5, type: 'music', name: '电子能量 · 运动健身', desc: '高动感节拍助力训练与跑步', count: 18, updatedAt: '5 天前', play: 512300, like: 20100,
          cover: "linear-gradient(rgba(0,0,0,.25),rgba(0,0,0,.25)), url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1200 400\"><rect width=\"1200\" height=\"400\" fill=\"%234f46e5\"/><circle cx=\"420\" cy=\"180\" r=\"110\" fill=\"%23ffffff22\"/></svg>')" },
        { id: 6, type: 'comic', name: '都市奇缘 · 浪漫恋曲', desc: '都市遇见与成长治愈系短篇', count: 7, updatedAt: '1 周前', play: 298800, like: 9900,
          cover: "linear-gradient(rgba(0,0,0,.25),rgba(0,0,0,.25)), url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1200 400\"><rect width=\"1200\" height=\"400\" fill=\"%23fb7185\"/><rect x=\"180\" y=\"100\" width=\"300\" height=\"180\" rx=\"18\" fill=\"%23ffffff22\"/></svg>')" }
      ]
    }
  },
  computed: {
    filteredCollections() {
      return this.collections
        .filter(c => this.currentTab === 'all' || c.type === this.currentTab)
        .filter(c => !this.keyword || c.name.includes(this.keyword) || c.desc.includes(this.keyword))
    },
    sortedCollections() {
      const arr = [...this.filteredCollections]
      if (this.sortKey === 'trending') {
        arr.sort((a, b) => (b.play + b.like) - (a.play + a.like))
      } else if (this.sortKey === 'recent') {
        // 简单映射更新时间权重（示意）
        const weight = v => (v.includes('今日') ? 100 : v.includes('本周') ? 80 : v.includes('本月') ? 60 : 40)
        arr.sort((a, b) => weight(b.updatedAt) - weight(a.updatedAt))
      } else if (this.sortKey === 'count') {
        arr.sort((a, b) => b.count - a.count)
      }
      return arr
    },
    visibleCollections() {
      return this.sortedCollections.slice(0, this.visibleCount)
    }
  },
  methods: {
    bg(cover) {
      return { backgroundImage: cover }
    },
    loadMore() {
      this.visibleCount = Math.min(this.visibleCount + this.loadStep, this.sortedCollections.length)
    },
    formatNumber(n) {
      if (n >= 1000000) return (n / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'
      if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'K'
      return n
    }
  }
}
</script>

<style scoped lang="scss">
.heji-page {
  background: #fff;
  color: #0f172a;
}

.container {
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 16px;
}

/* 顶部 */
.hero {
  padding: 88px 0 28px;
  background: #fff;
  border-bottom: 1px solid #f1f5f9;

  .title {
    margin: 0 0 8px;
    font-size: 40px;
    font-weight: 800;
    letter-spacing: -0.5px;
  }

  .subtitle {
    margin: 0;
    color: #64748b;
  }

  .filters {
    margin-top: 16px;
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .pill-group {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .pill {
    padding: 8px 14px;
    border-radius: 999px;
    border: 1px solid #e2e8f0;
    background: #fff;
    color: #0f172a;
    cursor: pointer;
    font-weight: 600;
    transition: all .2s ease;
  }

  .pill.active, .pill:hover {
    background: #0f172a;
    color: #fff;
    border-color: transparent;
  }

  .toolbar { display:flex; gap: 10px; align-items: center; }

  .search input {
    height: 40px;
    padding: 0 12px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #fff;
    color: #0f172a;
    outline: none;
    width: 240px;
  }

  .search input:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.12);
  }

  .sort select {
    height: 40px;
    padding: 0 12px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #fff;
    color: #0f172a;
    outline: none;
  }
}

/* 合集卡片 */
.collections {
  padding: 28px 0 60px;
  background: #fff;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
}

.collection-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;
}

.collection-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 36px rgba(2,8,23,.08);
  border-color: #cbd5e1;
}

.cover {
  position: relative;
  height: 160px;
  background-size: cover;
  background-position: center;
}

.overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(transparent, rgba(0,0,0,.35));
}

.tag {
  position: absolute;
  top: 12px; left: 12px;
  padding: 6px 12px;
  border-radius: 999px;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.tag-music { background: linear-gradient(135deg, #8b5cf6, #a855f7); }
.tag-comic { background: linear-gradient(135deg, #06b6d4, #0891b2); }

.info {
  padding: 14px 14px 16px;
}

.name { margin: 0 0 6px; font-size: 18px; color: #111827; }
.desc { margin: 0 0 10px; color: #64748b; line-height: 1.5; font-size: 14px; }

.meta-row { display:flex; align-items:center; justify-content: space-between; gap: 10px; margin-top: 6px; }
.meta-left { display:flex; align-items:center; gap:8px; color:#64748b; font-size:12px; }
.chip { padding: 3px 8px; background:#f8fafc; border:1px solid #e2e8f0; border-radius: 999px; }
.stats { display:flex; gap:10px; color:#475569; font-size:12px; }
.stat { display:flex; align-items:center; gap:6px; }
.stat i { display:inline-flex; align-items:center; justify-content:center; width:18px; height:18px; border-radius:5px; background:#eef2ff; color:#4f46e5; font-style: normal; font-size: 11px; font-weight: 800; }
.dot { opacity: .6; }

.actions { margin-top: 12px; display: flex; gap: 10px; }

.btn {
  height: 38px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #0f172a;
  text-decoration: none;
  font-weight: 700;
  display: inline-flex; align-items:center; justify-content:center;
  transition: all .2s ease;
}

.btn.primary { background: #667eea; color: #fff; border-color: #667eea; }
.btn.primary:hover { background: #5568d3; }
.btn.outline:hover { border-color: #94a3b8; }

.loadmore { display:flex; justify-content:center; }
.btn.more { margin-top: 16px; padding: 0 18px; height: 40px; border-radius: 999px; }

/* 关于区域 */
.about { padding: 20px 0 80px; border-top: 1px solid #f1f5f9; background: #fff; }
.about-grid { display: grid; grid-template-columns: 1.6fr .8fr; gap: 24px; align-items: start; }
.about-text h2 { margin: 0 0 10px; font-size: 28px; color: #0f172a; }
.about-text .desc { margin: 0 0 12px; color: #475569; line-height: 1.7; }
.bullets { margin: 0; padding-left: 18px; color: #334155; }

.about-cards { display: grid; grid-template-columns: 1fr; gap: 12px; }
.mini-card { display:flex; gap:12px; padding:12px; border:1px solid #e2e8f0; border-radius:12px; background:#fff; }
.mini-icon { width:36px; height:36px; border-radius:8px; display:flex; align-items:center; justify-content:center; }
.mini-card.music .mini-icon { background: #eef2ff; }
.mini-card.comic .mini-icon { background: #ecfeff; }
.mini-card.mix .mini-icon { background: #fdf4ff; }
.mini-content h4 { margin:0 0 2px; font-size:15px; color:#0f172a; }
.mini-content p { margin:0; font-size:13px; color:#64748b; }

/* 响应式 */
@media (max-width: 1024px) { .grid { grid-template-columns: repeat(2, 1fr); } .about-grid{ grid-template-columns: 1fr; } }
@media (max-width: 640px) { .grid { grid-template-columns: 1fr; } .hero .title { font-size: 28px; } .hero .search input{ width: 100%; } }
</style>
